import { AccountDetailsWebController } from '../controller/AccountDetailsWebController';
import { BaseWebComponentElement } from '../../../../framework/BaseWebComponentElement';
import { AccountActionContext } from '../../types/AccountActionContext';
import { AccountDetails } from '../types';
import { Observable } from 'rxjs';

export class AccountDetailsWebComponent extends BaseWebComponentElement {
  public controller!: AccountDetailsWebController;
  private viewData: AccountDetails;

  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: AccountDetailsWebController,
    });
  }

  public setViewData(accountDetails: AccountDetails): void {
    this.viewData = accountDetails;
  }

  public getViewData(): AccountDetails {
    return this.viewData;
  }

  public setActionContext(context: AccountActionContext): void {
    this.controller.view.context = context;
  }

  public getUserIdValue(): string {
    return this.controller.view.dom.$userId.value as string;
  }

  public getEmailValue(): string {
    return this.controller.view.dom.$emailFormField.value as string;
  }

  public getPasswordValue(): string {
    return this.controller.view.dom.$passwordFormField.value as string;
  }

  public getUsernameValue(): string {
    return this.controller.view.dom.$usernameFormField.value as string;
  }

  public getFullNameValue(): string {
    return this.controller.view.dom.$fullNameFormField.value as string;
  }

  public getSelectedTimezone(): string {
    return this.controller.view.dom.$timezoneFormField.value as string;
  }

  public getSelectedLanguage(): string {
    return this.controller.view.dom.$languageFormField.value as string;
  }

  public getPhoneNumberValue(): string {
    return this.controller.view.dom.$phoneNumberInput.getPhoneValue().subscriberNumber as string;
  }

  public getSelectedCountryCode(): string {
    return this.controller.view.dom.$phoneNumberInput.getPhoneValue().countryCode as string;
  }

  public getSelectedCompanyId(): string {
    return this.controller.view.getSelectedCompanyId() as string;
  }

  public get valid$(): Observable<boolean> {
    return this.controller.view.formGroup.valid$;
  }

  public get valid(): boolean {
    if (!this.controller.view.formGroup) {
      return false;
    }
    return this.controller.view.formGroup.valid;
  }

  public togglePasswordFields(showFields: boolean): void {
    this.controller.view.togglePasswordFields(showFields);
  }
}
